import {
    Table,
    TableBody,
    TableCell,
    TableCellProps,
    TableHead,
    TableRow,
    TableRowProps,
    useTheme,
} from "@mui/material"
import { TableColumn } from "../../models/Table"

interface NexTableCellProps<T> extends TableCellProps {
    sticky?: boolean
    stickyHeader?: boolean
    column?: TableColumn<T>
    selected?: boolean
}

export const NexTableCell = <T,>({
    sticky = false,
    stickyHeader,
    sx = [],
    children,
    column,
    selected,
    ...props
}: NexTableCellProps<T>) => {
    const theme = useTheme()
    const isSticky = stickyHeader ? true : sticky

    return (
        <TableCell
            {...props}
            sx={[
                ...(Array.isArray(sx) ? sx : [sx]),
                isSticky && {
                    p: 0,
                    position: "sticky",
                    left: 0,
                    width: "auto",
                    zIndex: theme.zIndex.mobileStepper,
                    backgroundColor: selected ? "#e0ecf2" : theme.palette.background.paper,
                    borderRight: "1px solid rgba(224,224,224,1)",
                },
                stickyHeader && {
                    zIndex: theme.zIndex.mobileStepper + 1,
                },
                column && {
                    minWidth: column.minWidth,
                    width: column.width,
                    maxWidth: column.maxWidth,
                },
                { whiteSpace: "nowrap" },
            ]}
        >
            {!isSticky && children}
            {isSticky && (
                <Table size="small" sx={{ display: "inline-flex" }}>
                    {stickyHeader && (
                        <TableHead>
                            <CustomTableRow>{children}</CustomTableRow>
                        </TableHead>
                    )}
                    {!stickyHeader && (
                        <TableBody>
                            <CustomTableRow>{children}</CustomTableRow>
                        </TableBody>
                    )}
                </Table>
            )}
        </TableCell>
    )
}

const CustomTableRow = ({ children }: TableRowProps) => {
    return <TableRow sx={{ "& > td, & > th": { border: "none" } }}>{children}</TableRow>
}

export const NexTableOverlayCell = ({ showOverlay, ...props }: { showOverlay: boolean } & TableCellProps) => {
    return (
        <TableCell
            sx={{
                position: "sticky",
                p: 0,
                alignItems: "center",
                visibility: showOverlay ? "visible" : "hidden",
                right: 0,
                border: "1px solid rgba(224, 224, 224, 1)",
                backgroundColor: (theme) => theme.palette.background.paper,
                opacity: 0.5,
                transition: "opacity 0.3s",
                "&:hover": { opacity: 1 },
            }}
            {...props}
        />
    )
}
